var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { primaryFont, primaryHeadingColor, wMBold } from '../../../Utils/utilsStyle';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import { useState } from 'react';
import styled from 'styled-components';
var TooltipWrapper = styled(Tooltip)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n.ant-tooltip-content {\n  .ant-tooltip-arrow {\n    transform: ", ";\n    .ant-tooltip-arrow-content {\n      left: ", ";\n    }\n  }\n  width: fit-content;\n  .ant-tooltip-inner {\n    color: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    font-style: normal !important;\n    font-size: 14px;\n    line-height: 16px;\n    letter-spacing: -0.4px;\n    padding: 7px 16px;\n    border-radius: 5px;\n    min-height: unset;\n    white-space: pre;\n  }\n}\n"], ["\n.ant-tooltip-content {\n  .ant-tooltip-arrow {\n    transform: ", ";\n    .ant-tooltip-arrow-content {\n      left: ", ";\n    }\n  }\n  width: fit-content;\n  .ant-tooltip-inner {\n    color: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    font-style: normal !important;\n    font-size: 14px;\n    line-height: 16px;\n    letter-spacing: -0.4px;\n    padding: 7px 16px;\n    border-radius: 5px;\n    min-height: unset;\n    white-space: pre;\n  }\n}\n"])), function (props) { return (props.outputAction ? 'translateX(97%) translateY(-50%)' : ''); }, function (props) { return props.arrowAlignment; }, primaryHeadingColor, primaryFont, wMBold);
var defaultProps = {
    arrowAlignment: '',
    customClassName: '',
    disableBtn: false,
    outputAction: false,
};
var IconTooltipGlobal = function IconTooltipGlobal(props) {
    var icon = props.icon, tooltipPlacement = props.tooltipPlacement, tooltipTitle = props.tooltipTitle, arrowAlignment = props.arrowAlignment, disableBtn = props.disableBtn, outputAction = props.outputAction, customClassName = props.customClassName;
    var _a = useState(false), visible = _a[0], setVisible = _a[1];
    var handleMouseEnter = function () {
        setVisible(true);
    };
    var handleMouseLeave = function () {
        setVisible(false);
    };
    var handleClick = function () {
        setVisible(false);
    };
    return (_jsx("div", __assign({ role: "button", tabIndex: 0, onClick: handleClick, onKeyDown: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, className: "icon-tooltip-global-wrapper ".concat(customClassName) }, { children: disableBtn ? (_jsx("span", __assign({ className: classNames('icon-tooltip-global', { disabled: disableBtn }) }, { children: icon }))) : (_jsx(TooltipWrapper, __assign({ arrowAlignment: arrowAlignment, outputAction: outputAction, placement: tooltipPlacement, getPopupContainer: function (e) { return e; }, color: "#fff", title: tooltipTitle, className: classNames('icon-tooltip-global'), mouseLeaveDelay: 0, visible: visible }, { children: _jsx("span", { children: icon }) }))) })));
};
IconTooltipGlobal.defaultProps = defaultProps;
export default IconTooltipGlobal;
var templateObject_1;
